import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Layout,
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: () => import('@/views/home/index'),
                    meta: {title: 'Astrolink', activeMenu: '/views/home'}
                }
            ]
        },
        {
            path: '/views',
            name: 'home',
            component: Layout,
            meta: {
                requireAuth: false,  // 判断是否需要登录
            },
            children: [
                {
                    path: '/views/home',
                    name: 'home',
                    component: () => import('@/views/home/index'),
                    meta: {title: 'Astrolink', activeMenu: '/views/home'}
                },
                {
                    path: '/views/watches',
                    name: 'watches',
                    component: () => import('@/views/watches/index'),
                    meta: {title: 'Astrolink', activeMenu: '/views/watches'}
                },
                {
                    path: '/views/watches/astrolinks',
                    name: 'astrolinks',
                    component: () => import('@/views/watches/astrolinks'),
                    meta: {title: 'Astrolink', activeMenu: '/views/watches'}
                },
                {
                    path: '/views/watches/astrolinkg',
                    name: 'astrolinkg',
                    component: () => import('@/views/watches/astrolinkg'),
                    meta: {title: 'Astrolink', activeMenu: '/views/watches'}
                },
                {
                    path: '/views/watches/astrolinku',
                    name: 'astrolinku',
                    component: () => import('@/views/watches/astrolinku'),
                    meta: {title: 'Astrolink', activeMenu: '/views/watches'}
                },
                {
                    path: '/views/astrolinku',
                    name: 'astrolinku',
                    component: () => import('@/views/astrolinku/index'),
                    meta: {title: 'Astrolink', activeMenu: '/views/astrolinku'}
                },
                {
                    path: '/views/support',
                    name: 'support',
                    component: () => import('@/views/support/index'),
                    meta: {title: 'Astrolink', activeMenu: '/views/support'}
                },
                {
                    path: '/views/support/afterSales',
                    name: 'afterSales',
                    component: () => import('@/views/support/afterSales'),
                    meta: {title: 'Astrolink', activeMenu: '/views/support'}
                },
                {
                    path: '/views/support/warrantyExtension',
                    name: 'warrantyExtension',
                    component: () => import('@/views/support/warrantyExtension'),
                    meta: {title: 'Astrolink', activeMenu: '/views/support'}
                },
                {
                    path: '/views/partners',
                    name: 'partners',
                    component: () => import('@/views/partners/index'),
                    meta: {title: 'Astrolink', activeMenu: '/views/partners'}
                },
                {
                    path: '/views/brand',
                    name: 'brand',
                    component: () => import('@/views/brand/index'),
                    meta: {title: 'Astrolink', activeMenu: '/views/brand'}
                }
            ]
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        // 始终滚动到顶部
        return { x: 0, y: 0 };
    }
})



// WEBPACK FOOTER //
// ./src/router/index.js